import { CSSProperties, FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 100px;
  cursor: pointer;
  padding: 15px 20px;

  &:hover {
    opacity: 0.8;
  }
`;

const Text = styled.p`
  font-size: 16px;
  font-weight: 400;
  margin: 0;
`;

const ChevronContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
`;

const withChevronStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
};
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  containerStyle?: CSSProperties;
  textStyle?: CSSProperties;
  text: string;
  onClick?: () => void;
  showChevron?: boolean;
}
export const Base: FC<ButtonProps> = ({ containerStyle, textStyle, text, onClick, disabled, showChevron = false, children }) => {
  let mergedContainerStyle = showChevron ? { ...withChevronStyle, ...containerStyle } : containerStyle;
  mergedContainerStyle = {
    ...mergedContainerStyle,
    opacity: disabled ? 0.5 : 1,
    cursor: disabled ? 'not-allowed' : 'pointer',
  };
  return (
    <Container onClick={disabled ? () => {} : onClick} style={mergedContainerStyle}>
      {children ? children : <Text style={textStyle}>{text}</Text>}
      {!!showChevron && (
        <ChevronContainer>
          <i className="Tiny material-icons" style={{ color: '#0092FF', fontSize: 24, fontWeight: 'bold' }}>
            chevron_right
          </i>
        </ChevronContainer>
      )}
    </Container>
  );
};

export default Base;
